module.exports = __webpack_public_path__ + "static/media/inf_27og28.64e260b1.mp3";